import { render, staticRenderFns } from "./errorList.vue?vue&type=template&id=572e8102&scoped=true&"
import script from "./errorList.vue?vue&type=script&lang=js&"
export * from "./errorList.vue?vue&type=script&lang=js&"
import style0 from "./errorList.vue?vue&type=style&index=0&id=572e8102&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e8102",
  null
  
)

export default component.exports